module.exports = {
	"help": {
		"main": {
			"title": "Dúvidas",
			"help": "Formulário de dúvidas"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/help/pt-BR.yml
// module id = 583
// module chunks = 1